import {
  Bank,
  AppError,
  API_ENDPOINTS,
  apiRequest,
  ReturnTypeWithPagination,
  timeAsSeconds,
} from "@alba-cars/common-modules";
import qs from "qs";

export const getPartneredBanks = async (): Promise<ReturnTypeWithPagination<Bank[]>> => {
  try {
    const endpoint = `${API_ENDPOINTS.bank.getAll.toString()}`;
    const queryString = qs.stringify(
      {
        limit: 500,
      },
      {
        skipNulls: true,
        allowEmptyArrays: false,
        allowDots: false,
        arrayFormat: "brackets",
      },
    );

    const fullEndpoint = `${endpoint}?${queryString}`;
    const response = await apiRequest<ReturnTypeWithPagination<Bank[]>>(fullEndpoint, {
      cache: "no-cache",
      next: {
        revalidate: timeAsSeconds({ minutes: 5 }),
        tags: ["banks", "partnered-banks"],
      },
    });

    return response;
  } catch (error: unknown) {
    return {
      success: false,
      data: {
        result: [],
        total: 0,
        limit: 500,
        page: 1,
      },
      error: error as AppError,
      message: "Failed to get partnered banks",
    };
  }
};
